import React from 'react';
import PropTypes from 'prop-types';
import MenuDropdownItem from './MenuDropdownItem';

const MenuDropdownEmptyItem = ({ index, children, ...rest }) => {
    if (!children) return null;

    return (
        <MenuDropdownItem {...rest} disabled index={index} value="">
            {children}
        </MenuDropdownItem>
    );
};

MenuDropdownEmptyItem.displayName = 'MenuDropdownEmptyItem';

MenuDropdownEmptyItem.propTypes = {
    index: PropTypes.number,
    children: PropTypes.string,
};

MenuDropdownEmptyItem.defaultProps = {
    index: 0,
    children: null,
};

export default MenuDropdownEmptyItem;
